import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ILocalTags {
  typeName: string
  tags: Array<string>
}

export interface ILocalInfo {
  areaId: number
  areaBounds: Array<any>
  areaBoundsXY: Array<any> //平面坐标系的位置
  tags: Array<ILocalTags>
}

export interface IGoutuTags {
  title: string
  imgSrc?: string
  description?: string
}

export interface IGlobalTagTree {
  主题: string[]
  类型: string[]
  材质: string[]
  形制: string[]
  意境: string[]
  构图: IGoutuTags[]
  题材: string[]
  设色: string[]
}

export interface ILocalTagTree {
  物象: string[]
  技法: string[]
}

export interface IGlobalTags {
  意境: string[]
  构图: string[]
}

export interface IColorInfo {
  name: string
  color: string
  percentage: string
}
export interface IRecommendImgs {
  uuid: string
  sim: number
}
export interface ICompareInfo {
  atrID: string
  date: string
  time: string
  globalTagTree: IGlobalTagTree
  localTagTree: ILocalTagTree
  globalTags: IGlobalTags
  localInfo: ILocalInfo[]
  colorBar: IColorInfo[]
  recommend: IRecommendImgs[]
  showType: number
}

const initialState: ICompareInfo = {
  atrID: '',
  date: '',
  time: '',
  globalTagTree: {
    主题: [],
    类型: [],
    材质: [],
    形制: [],
    意境: [],
    构图: [],
    题材: [],
    设色: []
  },
  localTagTree: {
    物象: [],
    技法: []
  },
  globalTags: {
    意境: [],
    构图: []
  },
  localInfo: [],
  colorBar: [],
  recommend: [],
  showType: 0
}

export const setCompareInfoSlice = createSlice({
  name: 'setCompareInfo',
  initialState,
  reducers: {
    setAtrID: (state, action: PayloadAction<string>) => {
      state.atrID = action.payload
    },
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload
    },
    setTime: (state, action: PayloadAction<string>) => {
      state.time = action.payload
    },
    setGlobalTagTree: (state, action: PayloadAction<IGlobalTagTree>) => {
      state.globalTagTree = action.payload
    },
    setLocalTagTree: (state, action: PayloadAction<ILocalTagTree>) => {
      state.localTagTree = action.payload
    },
    setGlobalTags: (state, action: PayloadAction<IGlobalTags>) => {
      state.globalTags = action.payload
    },
    setLocalInfo: (state, action: PayloadAction<ILocalInfo[]>) => {
      state.localInfo = action.payload
    },
    setColorBar: (state, action: PayloadAction<IColorInfo[]>) => {
      state.colorBar = action.payload
    },
    setRecommend: (state, action: PayloadAction<IRecommendImgs[]>) => {
      state.recommend = action.payload
    },
    setShowType: (state, action: PayloadAction<number>) => {
      state.showType = action.payload
    }
  }
})
export const {
  setAtrID,
  setDate,
  setTime,
  setGlobalTagTree,
  setLocalTagTree,
  setGlobalTags,
  setLocalInfo,
  setColorBar,
  setRecommend,
  setShowType
} = setCompareInfoSlice.actions
export default setCompareInfoSlice.reducer
